import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import MapIcon from "@mui/icons-material/Map";
import { useTranslation } from "react-i18next";

const PageContainer = {
  position: "relative",
  backgroundImage: `url('image/Mp.png')`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  borderBottomLeftRadius: "250px",
  borderTopRightRadius: "250px",
  borderLeft: '10px solid dodgerblue',
  borderRight: '10px solid dodgerblue',
  backgroundPosition: "center",
  minHeight: "100vh",
  padding: "48px 24px",
  color: "#f5f5f5",
  overflowX: "hidden",
  overflowY: "auto",
};

const Overlay = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(209, 209, 209, 0.8)",
  zIndex: 0,
};

const ContentWrapper = {
  position: "relative",
  zIndex: 1,
  maxWidth: 1200,
  margin: "0 auto",
};

const TextCard = {
  borderRadius: 20,
  backgroundColor: "rgba(39, 37, 37, 0.06)",
  backdropFilter: "blur(15px)",
  boxShadow: "0 20px 40px rgba(0,0,0,0.5)",
  padding: "32px 32px 40px",
  position: "relative",
  zIndex: 2,
};

export default function LuluaPresence() {
  const { t, i18n } = useTranslation();

  const currentLang = i18n.language;


  const locations = t('locations', { returnObjects: true });
 const isRTL = i18n.language === 'ar';

  const fontFamily = isRTL ? "'Tajawal', sans-serif" : 'inherit';
  return (
    <Box
      sx={{
        ...PageContainer,
        direction: isRTL ? 'rtl' : 'ltr',
      }}
    >
      <Box sx={Overlay} />
      <Box sx={ContentWrapper}>
        {/* Header */}
        <Box
          display="flex"
          alignItems="center"
          gap={2}
          mb={5}
         
        >
          <MapIcon sx={{ color: "dodgerblue", fontSize: 40 }} />
          <Typography fontFamily={fontFamily} variant="h3" fontWeight="bold">
            {t('header')}
          </Typography>
        </Box>

        <Grid
          container
          spacing={4}
          sx={{ position: "relative" }}
          direction={isRTL ? 'row-reverse' : 'row'}
        >
          {/* Text Card */}
          <Grid item xs={12} md={6} sx={{ zIndex: 3 }}>
            <Card sx={TextCard}>
              <CardContent>
                <Typography
                fontFamily={fontFamily}
                  variant="body1"
                  fontWeight={600}
                  gutterBottom
                  textAlign={isRTL ? 'right' : 'left'}
                >
                  {t('developingProjects')}
                </Typography>
                <ul style={{
                  paddingLeft: isRTL ? 0 : 20,
                  paddingRight: isRTL ? 20 : 0,
                  marginTop: 16,
                  direction: isRTL ? 'rtl' : 'ltr'
                }}>
                  {locations.map((location, index) => (
                    <li key={index} style={{ marginBottom: 10 }}>
                      <Typography
                      
                       fontFamily={fontFamily}
                        gap={1}
                        variant="body2"
                        sx={{
                       
                         
                        }}
                      >
                        <LocationOnIcon
                          sx={{ color: "dodgerblue" }}
                          fontSize="small"
                        />
                        {location}
                      </Typography>
                    </li>
                  ))}
                </ul>
                <Typography
                fontFamily={fontFamily}
                  mt={3}
                  fontWeight={500}
                  fontSize={16}
                  lineHeight={1.6}
                  textAlign={isRTL ? 'right' : 'left'}
                >
                  {t('futureVision')}
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Right Floating Map Card */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              position: "relative",
              top: { xs: 0, md: "-60px" },
              left: { xs: 0, md: isRTL ? "-40px" : "40px" },
              zIndex: 4,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/* Add your map or other content here */}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
